// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"bp-z","outfitFeedbackSection":"cp-z"};